// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__2Zom0","footer":"ModalFilter_footer__2H7VG"};